// This file was generated using `pay js:run gql-v1 --type=fragment --name=StripeAccountRequirementsAlternativeArk --dir=path/to/dir`.
// To generate yours, do not copy and paste; use the command above instead. Do not delete this comment.

/* eslint-disable @stripe-internal/data-v1/camel-case-alias */

import {gql} from '@sail/data';

import type {GraphQlDocument} from '@sail/data';
import type {Exact} from '@stripe-internal/data-v1/schema/types';

import type {V1PermissionToken} from '@stripe-internal/data-v1/types';

const doc = gql`
  fragment StripeAccountRequirementsAlternativeArkFragment on OpenapiAccountRequirementsAlternative {
    alternative_fields_due
    original_fields_due
  }
`;

export const stripeAccountRequirementsAlternativeArkFragment: StripeAccountRequirementsAlternativeArkFragmentDocument =
  doc;

// THIS IS AUTOGENERATED CODE, DO NOT EDIT AS YOUR CHANGES WILL BE BLOWN AWAY
// Regenerate it using eslint in fix mode.

export type StripeAccountRequirementsAlternativeArkFragmentData = {
  readonly __typename: 'OpenapiAccountRequirementsAlternative';
  readonly alternative_fields_due: ReadonlyArray<string>;
  readonly original_fields_due: ReadonlyArray<string>;
};

export type StripeAccountRequirementsAlternativeArkFragmentVariables = Exact<{
  [key: string]: never;
}>;

const stripeAccountRequirementsAlternativeArkFragmentPermissions = {} as const;

doc.permissions = stripeAccountRequirementsAlternativeArkFragmentPermissions;

export type StripeAccountRequirementsAlternativeArkFragmentPermissions =
  V1PermissionToken<
    typeof stripeAccountRequirementsAlternativeArkFragmentPermissions
  >;

export type StripeAccountRequirementsAlternativeArkFragmentDocument =
  GraphQlDocument<
    StripeAccountRequirementsAlternativeArkFragmentData,
    StripeAccountRequirementsAlternativeArkFragmentVariables,
    StripeAccountRequirementsAlternativeArkFragmentPermissions
  >;
